const form = document.getElementById("contact_form");

// フォーム要素の存在確認
if (!form) {
  console.warn("Contact form not found. Skipping custom stock form initialization.");
}

// 隠しフィールドを更新する関数
function updateHiddenFields() {
    if (!form) {
        return;
    }

    const parentSpans = document.querySelectorAll('.options-selection__option-name');

    for (let i = 0; i < parentSpans.length; i++) {
        const fullText = parentSpans[i].textContent || parentSpans[i].innerText;
        const childSpan = parentSpans[i].querySelector('span');
        
        if (!childSpan) {
            continue;
        }
        
        const childText = childSpan.textContent || childSpan.innerText;
        const option_name = fullText.replace(childText, '').trim();
        const option_value = childText.trim();

        // フィールド識別子を生成
        const fieldId = "hidden_" + option_name.replace(/[^a-zA-Z0-9]/g, "_"); // 特殊文字をアンダースコアに置換

        // 既存の隠しフィールドを検索
        const existingInput = form.querySelector('input[id="' + fieldId + '"]');

        if (existingInput) {
            // 既存のフィールドがある場合は値を更新
            existingInput.value = option_value;
        } else {
            // 新しい隠しフィールドを作成
            const hiddenInput = document.createElement("input");
            hiddenInput.setAttribute("type", "hidden");
            hiddenInput.setAttribute("id", fieldId);
            hiddenInput.setAttribute("name", "contact[" + option_name + "]");
            hiddenInput.setAttribute("value", option_value);
            form.appendChild(hiddenInput);
        }
    }
}

// オプション変更のボタン要素を取得 (ボタンのクラスまたはIDに応じて適宜変更)
const optionChangeButtons = document.querySelectorAll('.options-selection__option-value');

if (optionChangeButtons.length > 0) {
    optionChangeButtons.forEach(button => {
        button.addEventListener('click', function() {
            // 10ミリ秒待ってからupdateHiddenFieldsを実行（DOM更新を待つ）
            setTimeout(updateHiddenFields, 10);
        });
    });
}

// 初期ロード時にも隠しフィールドを設定
if (form) {
    updateHiddenFields();
}
